import React from 'react';
import './LoadingSpinner.css';

function LoadingSpinner({ 
  size = 'medium', 
  message = 'Loading...', 
  variant = 'default',
  className = ''
}) {
  const sizeClass = {
    small: 'sae-spinner-small',
    medium: 'sae-spinner-medium',
    large: 'sae-spinner-large'
  }[size] || 'sae-spinner-medium';

  const variantClass = {
    default: '',
    inline: 'sae-inline',
    fullscreen: 'sae-fullscreen',
    overlay: 'sae-overlay'
  }[variant] || '';

  return (
    <div className={`sae-loading-spinner-container ${variantClass} ${className}`}>
      <div className={`sae-loading-spinner ${sizeClass}`}>
        <div className="sae-spinner-icon"></div>
        {message && <div className="sae-spinner-text">{message}</div>}
      </div>
    </div>
  );
}

export default LoadingSpinner; 